import styled from 'styled-components';
import Button from 'components/button/Button';
import { BreadcrumbsWrapper } from '../components/breadcrumbs/Breadcrumbs.styles';

export const IntegrationConnectionWrapper = styled.div.attrs({
  className: 'container',
})`
  ${BreadcrumbsWrapper} {
    margin-bottom: 20px;
  }

  .bd-callout {
    margin: 0;
  }
`;

export const TitleStyled = styled.h1`
  font-weight: 700;
  font-size: 20px;
  margin: 0;
  color: #212529;
`;

export const DescriptionStyled = styled.p`
  font-weight: 400;
  font-size: 16px;
  margin: 0;
  color: #212529;
`;

export const ButtonStyled = styled(Button)`
  width: fit-content;
`;

export const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const PaymentWarningContainerStyled = styled.div.attrs({
  className: 'bd-callout bd-callout-warning',
})`
  display: flex;
  align-items: center;
  gap: 5px;

  .tooltip-container {
    height: 16px;
  }
`;
